﻿<ss-popup>
  <div class="width-250">
    <h3 class="popup-title">{{ titleText }}</h3>

    <ng-container *ngIf="helperText">
      <p class="txt-sans-serif">
        {{ helperText }}
      </p>
    </ng-container>
    
    <ng-container *ngIf="warningText">
      <p class="txt-sans-serif txt-italic color-red-base">
        {{ warningText }}
      </p>
    </ng-container>


    <div class="clearfix margin-top-25">
      <button (click)="emitOnCancel()"
      class="btn-secondary margin-right-15 margin-bottom-10">
      {{ cancelText }}
      </button>

      <button (click)="emitOnSubmit()"
      class="margin-bottom-10"
      [class.btn-red]="type == 'warn'"
      [class.btn-primary]="type == 'confirm'">
        {{ submitText }}
      </button>
    </div>
  </div>
</ss-popup>
